var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.crossSellingItems.length,
          expression: "crossSellingItems.length",
        },
      ],
      staticClass: "cross-selling-wrapper mt-2 component-loading with-icon",
      class: { isLoading: _vm.isBasketLoading },
    },
    [
      _c("hr"),
      _vm._v(" "),
      _c("p", { staticClass: "title" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$translate(
                "PerformanceWheels::Template.crossSellingAccessoryTitle"
              )
            )
        ),
        _c("span", { staticClass: "ml-2" }, [
          _vm._v(
            _vm._s(
              _vm.$translate(
                "PerformanceWheels::Template.crossSellingAccessoryTitleDescription"
              )
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cross-selling-row " }, [
        _c(
          "div",
          { staticClass: "row no-gutters" },
          _vm._l(_vm.crossSellingItems, function (crossItm) {
            return _c(
              "div",
              {
                key: crossItm.variation.id,
                staticClass: "col-12 col-sm-6 col-lg-12_ p-1",
              },
              [
                _c("popper", {
                  staticClass: "popper d-inline-flex align-self-center pr-2",
                  attrs: { placement: "left" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "handle",
                        fn: function () {
                          return [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-icon btn-secondary btn-sm p-2",
                              },
                              [_c("i", { staticClass: "fa fa-info" })]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(crossItm.texts.shortDescription) +
                                "\n          "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _c(
                  "article",
                  {
                    staticClass:
                      "cmp cmp-product-thumb h-100_X mb-0 p-0 accessory-item cross-item",
                    class: {
                      "cross-item-active": _vm.selectedCrossItems.some(
                        function (si) {
                          return si.variationId === crossItm.variation.id
                        }
                      ),
                    },
                    attrs: {
                      "data-item-id": crossItm.item.id,
                      "data-price": crossItm.prices.default.unitPrice.value,
                      "data-variation-id": crossItm.variation.id,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.toggleCrossSellingItem(crossItm.variation.id)
                      },
                    },
                  },
                  [
                    _vm.hasItemTooltip(crossItm)
                      ? _c("div", {
                          directives: [
                            { name: "tooltip", rawName: "v-tooltip" },
                          ],
                          staticClass: "cross-tooltip",
                          attrs: {
                            "data-toggle": "tooltip",
                            "data-placement": "top",
                            title: crossItm.texts.shortDescription,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "thumb-inner d-flex flex-sm-column_X h-100",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "thumb-image col-3 col-sm-4" },
                          [
                            _vm.hasItemImage(crossItm)
                              ? _c("img", {
                                  attrs: {
                                    src: crossItm.images.all[0].urlMiddle,
                                    alt: crossItm.texts.name1,
                                  },
                                })
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "thumb-content d-flex flex-column col-9 col-sm-8",
                          },
                          [
                            _c("div", { staticClass: "name" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(crossItm.texts.name1) +
                                  "\n                "
                              ),
                              _c("span", { staticClass: "unitNumber" }, [
                                _vm._v(_vm._s(crossItm.texts.name2)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "prices d-flex align-items-end" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "price text-color-primary ml-auto",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  + " +
                                        _vm._s(
                                          crossItm.prices.default.unitPrice
                                            .formatted
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }